import {gsap} from "gsap";
import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";
import {WinConfig, WinConfigUtil} from "../../utils/WinConfigUtil";
import {TheCage} from "../../TheCage";
import {TheCageGameMode} from "../../server/TheCageGameMode";
import {TheCageStatics} from "../../config/TheCageStatics";
import {TheCageSound} from "../../sound/TheCageSound";
import {WinSummery} from "../maingame/win/WinSummery";


/**
 * Created by jonas on 2022-01-12.
 */

export class FreeSpinWinSummery extends WinSummery {
    name:string = "FreeSpinWinSummery";

    shouldRun():boolean {
        return TheCage.model.winData.accumulatedWinRatio > 0 &&
            (TheCage.model.data.nextMode == TheCageGameMode.FREESPIN || TheCage.model.data.nextMode == TheCageGameMode.NORMAL) &&
            !TheCage.model.gameData.brokeTheBank && !TheCage.isWinBelowStake();
    }

    constructor() {
        super();
    }
}